import React, { useCallback, useState } from 'react';

import { Progress } from './Progress';
import { Container, Overlay } from './styles';

interface StoriesProps {
    steps: React.ReactNode[];
    duration?: number;
    isInverted?: boolean;
    infinityLoop?: boolean;
}

export const Stories: React.FC<StoriesProps> = ({ steps, duration, isInverted, infinityLoop }) => {
    const [currentStepNumber, setCurrentStepNumber] = useState(0);
    const [isPaused, setIsPaused] = useState(false);
    const [pressedDate, setPressedDate] = useState<number | null>(null);

    const overlayPressed = () => {
        setPressedDate(Date.now());
        setIsPaused(true);
    };

    const overlayReleased = (action: () => void) => {
        if (pressedDate !== null && Date.now() - pressedDate < 200) {
            action();
        }

        setPressedDate(null);
        setIsPaused(false);
    };

    const previousStep = useCallback(() => {
        setCurrentStepNumber((step) => {
            const isFirstStepIndex = step === 0;
            return isFirstStepIndex ? (infinityLoop ? steps.length - 1 : step) : step - 1;
        });
    }, [steps.length, infinityLoop]);

    const nextStep = useCallback(() => {
        setCurrentStepNumber((step) => {
            const isLastStepIndex = step === steps.length - 1;
            return isLastStepIndex ? (infinityLoop ? 0 : step) : step + 1;
        });
    }, [steps.length, infinityLoop]);

    const nextReleased = () => overlayReleased(nextStep);
    const previousReleased = () => overlayReleased(previousStep);

    return (
        <Container>
            {steps.length > 1 && (
                <Progress
                    count={steps.length}
                    isPaused={isPaused}
                    currentStep={currentStepNumber}
                    onStepComplete={nextStep}
                    duration={duration}
                    isInverted={isInverted}
                />
            )}
            {steps[currentStepNumber]}
            <Overlay>
                <div
                    onTouchStart={overlayPressed}
                    onTouchEnd={previousReleased}
                    onMouseDown={overlayPressed}
                    onMouseUp={previousReleased}
                    onContextMenu={(event) => event.preventDefault()}
                />
                <div
                    onTouchStart={overlayPressed}
                    onTouchEnd={nextReleased}
                    onMouseDown={overlayPressed}
                    onMouseUp={nextReleased}
                    onContextMenu={(event) => event.preventDefault()}
                />
            </Overlay>
        </Container>
    );
};
